import axios from "axios";
import { endpoints } from "config/api";
import { getToken } from "./helpers/utilities";
import { axiosErrorHandler } from "./helpers/axiosHelpers";

//get upcoming appointmnet
export const getAllUpcomingAppointmentApi = async (data) => {
  console.log(data, "shfj");
  let request = await axios({
    method: "post",
    url: endpoints.appointment.GET_ALL_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//get completed appointment
export const getAllCompletedAppointmentApi = async (data) => {
  console.log(data, "shfj");
  let request = await axios({
    method: "post",
    url: endpoints.appointment.GET_ALL_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

// get follow-up appointments
export const getAllFollowupAppointmentApi = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.appointment.GET_ALL_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//get single appointment
export const getSingleAppointmentApi = async (id) => {
  let request = await axios({
    method: "get",
    url: `${endpoints.appointment.GET_SINGLE_APPOINTMENT}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    // data: data,
  }).catch(axiosErrorHandler);
  return request;
};

export const getSingleAppointmentApiWithMobileNumber = async (mobileNumber) => {
  let request = await axios({
    method: "get",
    url: `${endpoints.appointment.GET_SINGLE_APPOINTMENT}?patientMobileNumber=${mobileNumber}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    // data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//get appointment settings api
export const getAppointmentSettingsApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.appointment.GET_APPOINTMENT_SETTINGS,

    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

// cancel appointment
export const cancelAppointmentApi = async (id) => {
  let request = await axios({
    method: "post",
    url: `${endpoints.appointment.CANCEL_APPOINTMENT}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return request;
};

// reschedule appointment
export const updateAppointmentApi = async (id, data) => {
  let request = await axios({
    method: "put",
    url: `${endpoints.appointment.UPDATE_APPOINTMENT}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//get all speciality
export const getAllSpecialityApi = async (id, data) => {
  let request = await axios({
    method: "get",
    url: endpoints.appointment.GET_ALL_SPECIALITY,
    // headers: {
    //   Authorization: "Bearer " + getToken(),
    // },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//get Slots for SP
export const getSlotsSpApi = (params) => {
  let request = axios({
    method: "get",
    url: endpoints.appointment.GET_SP_SLOTS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};
export const getSlotsGpApi = (params) => {
  let request = axios({
    method: "get",
    url: endpoints.appointment.GET_GP_SLOTS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};
export const getSlotsGpApiFollow = (params) => {
  let request = axios({
    method: "get",
    url: endpoints.appointment.GET_GP_SLOTS_FOLLOW,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};
export const getGeneralSlotsApi = (params) => {
  let request = axios({
    method: "get",
    url: endpoints.appointment.GET_GENERAL_SLOTS,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};
export const getGPSLOTApi = (params) => {
  let request = axios({
    method: "get",
    url: endpoints.appointment.GET_GP_DOCSLOT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};

//reschedule appointment
export const appointmentRescheduleApi = (body, id, doctorId) => {
  console.log(id, "iiiiii");
  let request = axios({
    method: "put",
    url: `${endpoints.appointment.UPDATE_APPOINTMENT}/${id}?doctorId=${doctorId}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: body,
  }).catch(axiosErrorHandler);
  return request;
};

//view precription
export const getAllPrescriptionData = (id) => {
  console.log(id, "idddddddddddd");
  let request = axios({
    method: "get",
    url: `${endpoints.prescription.GET_ALL_PRESCRIPTION}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const connectVoiceCall = async (data) => {
  const request = await axios({
    method: "get",
    url: `${endpoints.appointment.CONNECT_VOICE_CALL}?id=${data?._id}&source=${data?.source}&clientId=${data?.createdBy}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);

  return request;
};

export const getConsultationByCondition = (data) => {
  let url = endpoints.appointment.GET_CONSULTATION_BY_COND;
  if (data?.meetingId) url += `?meetingId=${data?.meetingId}`;
  const request = axios({
    method: "get",
    url,
  }).catch(axiosErrorHandler);
  return request;
};

export const MarkAsAttended = async (data = {}) => {
  const request = await axios({
    data,
    method: "post",
    url: `${endpoints.appointment.IS_APPOINTMENT_ATTENDED}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);

  return request;
};

// reschedule appointment
export const updateAppointment = async (id, data) => {
  let request = await axios({
    method: "put",
    url: `${endpoints.appointment.UPDATE_MEMBER_ADDED}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

export const getFamilyConsultation = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.appointment.GET_ALL_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

export const getSpecialityApi = async () => {
  let request = await axios({
    method: "get",
    url: endpoints.appointment.GET_SPECIALITY_LIST,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

//create appointment
export const CreateAppointment = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.appointment.CREATE_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data,
  }).catch(axiosErrorHandler);
  return request;
};

//close consultation appointment
export const CloseConsultationAppointment = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.appointment.CLOSE_CONSULTATION_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data,
  });
  return request;
};

//close call consultation appointemnt
export const CloseCallConsultationAppointment = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.appointment.CLOSE_CALL_APPOINTMENT,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data,
  });
  return request;
};

//next availablility
export const GetDoctorNextAvailability = async (id, date) => {
  let request = axios({
    method: "get",
    url: `${endpoints.appointment.GET_DOCTOR_NEXT_AVAILABLE}/${id}?date=${date}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};


export const getVoiceCall = (params, id) => {
  let request = axios({
    method: "get",
    url: `${endpoints.appointment.GET_VOICE_CALL}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};

export const getVideoCall = (params, id) => {
  let request = axios({
    method: "get",
    url: `${endpoints.appointment.GET_VIDEO_CALL}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    params: params,
  }).catch(axiosErrorHandler);
  return request;
};


export const getVoiceCallById = (id) => {
  let request = axios({
    method: "get",
    url: `${endpoints.appointment.GET_VOICE_CALL_BY_ID}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const getVideoCallById = (id) => {
  let request = axios({
    method: "get",
    url: `${endpoints.appointment.GET_VIDEO_CALL_BY_ID}/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  }).catch(axiosErrorHandler);
  return request;
};


//get family member
export const getFamilyMembersApi = (aptId, userId) => {
  let request = axios({
    method: "get",
    url:
      endpoints.profile.GET_FAMILY_MEMBERS +
      `${aptId ? `?aptId=${aptId}` : ""}&userId=${userId ? userId : ""}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Source: "Doctor"
    },
  }).catch(axiosErrorHandler);
  return request;
};


export const updateDoctNote = (aptId, payload) => {
  let request = axios({
    method: "PUT",
    url:
      endpoints.appointment.UPDATE_DOCT_NOTE + `/${aptId}`,
    data: payload,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Source: "Doctor"
    },
  }).catch(axiosErrorHandler);
  return request;
};

export const getMedicineById = (aptId) => {
  let request = axios({
    method: "get",
    url:
      endpoints.prescription.GET_MEDICINE_BY_ID + `/${aptId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Source: "Doctor"
    },
  }).catch(axiosErrorHandler);
  return request;
};
